import React, { useState } from "react";
import { FaStar } from "react-icons/fa";

import { StarIcon } from "@heroicons/react/24/solid";

// import reviewPerson from "/home/person-review.png";

const colors = {
  orange: "#FFBA5A",
  grey: "#a9a9a9",
};

const styles: any = {
  stars: {
    display: "flex",
    flexDirection: "row",
  },
  textarea: {
    border: "1px solid #a9a9a9",
    borderRadius: 5,
    padding: 10,
    margin: "5px 0",
    width: "100%",
  },
  input: {
    width: "100%",
    border: "1px solid #a9a9a9",
    borderRadius: 5,
    height: "45px",
  },
  button: {
    border: "1px solid #a9a9a9",
    borderRadius: 5,
    backgroundColor: "#000",
    color: "white",
    padding: "2px 15px",
    fontWeight: 700,
    cursor: "pointer",
  },
};
export default function CommentReview() {
  const [currentValue, setCurrentValue] = useState(0);
  const [hoverValue, setHoverValue] = useState(undefined);
  const stars = Array(5).fill(0);

  const handleClick = (value: any) => {
    setCurrentValue(value);
    // console.log(value)
  };

  const handleMouseOver = (newHoverValue: any) => {
    setHoverValue(newHoverValue);
  };

  const handleMouseLeave = () => {
    setHoverValue(undefined);
  };

  return (
    <div className="">
      <h5 className="mt-4">Readers' reviews</h5>

      <div className="mt-4">
        <>
          <div className="">
            <div className="flex review-img">
              <div>
                <img src="/home/person-review.png" alt="" />
              </div>
              <div className="ms-3 mt-[-10px]">
                <p>Shahnewaj Islam </p>
              </div>
            </div>
            <div className="flex ms-[60px] mt-[-10px]">
              <StarIcon className="starIcon-5" />
              <StarIcon className="starIcon-5" />
              <StarIcon className="starIcon-5" />
              <StarIcon className="starIcon-5" />
              <StarIcon className="starIcon-5" />
            </div>
          </div>
        </>

        <hr className="mt-5" />
        <p>Write a comment</p>
        <div className="flex items-center">
          <div>
            <span className="text-red-500 font-bold">Select the rating</span>
          </div>
          <div style={styles.stars} className="ms-2">
            {stars.map((_, index) => {
              return (
                <FaStar
                  key={index}
                  size={20}
                  style={{
                    marginRight: 10,
                    cursor: "pointer",
                  }}
                  color={
                    (hoverValue || currentValue) > index
                      ? colors.orange
                      : colors.grey
                  }
                  onClick={() => handleClick(index + 1)}
                  onMouseOver={() => handleMouseOver(index + 1)}
                  onMouseLeave={() => handleMouseLeave()}
                />
              );
            })}
          </div>
        </div>
        <div>
          <div className="mt-3">
            <form>
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  style={styles.input}
                  className="px-3"
                />
              </div>
              <div>
                <textarea
                  name="comment"
                  placeholder="What's your experience?"
                  style={styles.textarea}
                  required
                />
              </div>
              <div className="flex justify-start">
                <div>
                  <input
                    type="submit"
                    className="hover:bg-red-500 bg-[#000] text-white px-3 py-2 rounded cursor-pointer"
                    value="Submit"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
